import { render, staticRenderFns } from "./UserLeaveHistoryWidget.vue?vue&type=template&id=0314595e&scoped=true"
import script from "./UserLeaveHistoryWidget.vue?vue&type=script&lang=js"
export * from "./UserLeaveHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./UserLeaveHistoryWidget.vue?vue&type=style&index=0&id=0314595e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0314595e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VPagination,VProgressCircular,VSimpleTable})
